import { render, staticRenderFns } from "./NewRegistrationForm.vue?vue&type=template&id=b80adc5a&scoped=true&"
import script from "./NewRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80adc5a",
  null
  
)

export default component.exports